module.exports = __webpack_public_path__ + "img/icon-profile-gray.6efc1023.svg";